<!--
 * @Descripttion: 
 * @version: 
 * @Author: lfs
 * @Date: 2021年06月25日 16:10:59
-->
<template>
  <div class="sub-title">
    <h2 class="">{{ title }}</h2>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
  props: {
    title: {
      default: '',
      type: String,
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.sub-title {
  margin-bottom: 18px;
  h2 {
    font-weight: bold;
    font-size: 16px;
    line-height: 1.2;
    &::before {
      content: '';
      width: 4px;
      height: 17px;
      background: $--color-primary;
      display: inline-block;
      vertical-align: bottom;
      margin-right: 10px;
      border-radius: 4px;
    }
  }
}
</style>
